import { render, staticRenderFns } from "./LoansChecklist.vue?vue&type=template&id=579affdc&scoped=true"
import script from "./LoansChecklist.vue?vue&type=script&lang=js"
export * from "./LoansChecklist.vue?vue&type=script&lang=js"
import style0 from "./LoansChecklist.vue?vue&type=style&index=0&id=579affdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579affdc",
  null
  
)

export default component.exports